<template>
  <v-card :loading="loading">
    <v-form>
      <v-container>
        <fieldset>
          <v-row>
            <v-col cols="12">
              <non-form-field-errors :errors="errors"></non-form-field-errors>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Student First Name</label>
              <v-text-field
                v-model="data.std_fname"
                :error-messages="errors.std_fname"
                label="Student First Name"
                placeholder="Student First Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Student Last Name</label>
              <v-text-field
                v-model="data.std_lname"
                :error-messages="errors.std_lname"
                label="Last Name"
                placeholder="Last Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Gaurdian First Name</label>
              <v-text-field
                v-model="data.gaurdian_fname"
                :error-messages="errors.gaurdian_fname"
                label="Gaurdian First Name"
                placeholder="Gaurdian First Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Gaurdian Last Name</label>
              <v-text-field
                v-model="data.gaurdian_lname"
                :error-messages="errors.gaurdian_lname"
                label="Gaurdian Last Name"
                placeholder="Gaurdian Last Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Gaurdian Phone Number</label>
              <v-text-field
                v-model="data.gaurdian_contactno"
                :error-messages="errors.gaurdian_contactno"
                label="Gaurdian Phone Number"
                placeholder="Gaurdian Phone Number"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Gaurdian Email</label>
              <v-text-field
                v-model="data.gaurdian_email"
                :error-messages="errors.gaurdian_email"
                label="Gaurdian Email"
                placeholder="Gaurdian Email"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Student School Name</label>
              <v-text-field
                v-model="data.std_school_name"
                :error-messages="errors.std_school_name"
                label="Student School Name"
                placeholder="Student School Name"
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Student Address</label>
              <v-text-field
                v-model="data.std_address"
                :error-messages="errors.std_address"
                label="Student Address "
                placeholder="Student Address"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">School Year</label>
              <v-select v-model="data.std_school_year_id" :error-messages="errors.std_school_year_id" :items="school_years" label="Choose School Year"
                placeholder="Choose School Year" solo single-line item-value="school_year_id" item-text="school_year_name"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn :loading="loading" color="primary" @click="save"
                >Update</v-btn
              >
            </v-col>
          </v-row>
        </fieldset>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import Form from "../../utils/form";
import NonFormFieldErrors from "../utils/errors/NonFormFieldErrors";

export default {
  name: "GroupForm",
  components: {
    NonFormFieldErrors,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      errors: {},
      school_years: [],
      data: {
        std_fname: null,
        std_lname: null,
        gaurdian_contactno: null,
        gaurdian_email: null,
        gaurdian_fname: null,
        gaurdian_lname: null,
        std_school_name: null,
        std_address: null,
        std_school_year_id: null,
      },
    };
  },
  methods: {
    setValues(student) {
      this.data.std_fname = student.std_fname;
      this.data.std_lname = student.std_lname;
      this.data.gaurdian_contactno = student.gaurdian_contactno;
      this.data.gaurdian_email = student.gaurdian_email;
      this.data.gaurdian_fname = student.gaurdian_fname;
      this.data.gaurdian_lname = student.gaurdian_lname;
      this.data.std_school_name = student.std_school_name;
      this.data.std_address = student.std_address;
      this.data.std_school_year_id = student.school_year.school_year_id;
      this.school_years = student.school_years;
    },
    getStudent() {
      axios.get(apiRoutes.students.url + "/" + this.id).then((response) => {
        this.setValues(response.data);
      });
    },
    save() {
      this.loading = true;
      if (this.id) {
        this.update();
      }
    },
    update() {
     
      let form = new Form({
        ...this.data,
      });
      form
        .put(apiRoutes.students.url + "/" + this.id)
        .then((response) => {
          this.loading = false;
          console.log("response.data.student", response.data.student);
          Toast.fire({
            icon: response.status,
            title: response.message,
          });
          this.setValues(response.data.student);
          
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          this.loading = false;
        });
    },
  },
  created() {
    this.loading = false;
    if (this.id) {
      this.getStudent();
    }
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }

  & label {
    font: Bold 15px/40px Lato;
    color: #172b4d;
  }
}
</style>
